export const getDateFromISOString = (dateString: string): string => dateString.slice(0, 10);
